var React = require('react');

function Right (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M10 20.5484L28.5189 20.5484L21.9351 14L23.9135 12L34 22.0323L23.9135 32L21.9351 30L28.5514 23.4516L10 23.4516L10 20.5484Z","fill":"black","key":1})]);
}

Right.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Right;

Right.default = Right;
